import { Badge, Button, Dropdown, Flex, Tag, Col } from 'antd';
import NavCommunity from './NavCommunity';
import { UserOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useAuth } from 'react-oidc-context';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import useBreakpoint from 'use-breakpoint';
import { useStore } from '../../../root-store-context';
import { RouteElement } from '../../../stores/appStores/ApplicationStore';
import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

interface CustomProfile {
    given_name?: string;
    lastName?: string;
    email?: string;
}

const NavBar: React.FC = observer(() => {
    const auth = useAuth();
    const profile = auth?.user?.profile as CustomProfile | undefined;
    const location = useLocation();
    const { applicationStore, apiStore } = useStore();
    const navigate = useNavigate();
    const { breakpoint } = useBreakpoint({
        mobile: 0,
        tablet: 768,
        desktop: 992,
    });

    const onLogOut = () => {
        const args = {
            extraQueryParams: {
                post_logout_redirect_uri: process.env
                    .REACT_APP_REDIRECT_URI as string,
                returnUrl: window.location.pathname + window.location.search + window.location.hash,
            },
        };
        void auth.signoutRedirect(args);
    };

    const FetchCount = () => {
        let residentKey =
            apiStore?.configApi?.community?.residentKey?.toString();
        // API call logic (commented)
    };

    useEffect(() => {
        FetchCount();
    }, []);

    useEffect(() => {
        if (applicationStore?.CardItemPayment) {
            FetchCount();
            applicationStore.setCardItemPayment(false);
        }
    }, [applicationStore?.CardItemPayment]);

    // 👉 Build menu items dynamically based on breakpoint
    const menuItems: MenuProps['items'] =
        breakpoint === 'mobile' || breakpoint === 'tablet'
            ? [
                  {
                      key: 'userInfo',
                      label: (
                          <div style={{ padding: '8px 8px', color: '#555' }}>
                              <div style={{ fontWeight: 600 }}>
                                  {profile?.given_name} {profile?.lastName}
                              </div>
                              <div style={{ fontSize: 12, color: '#555' }}>
                                  {profile?.email}
                              </div>
                          </div>
                      ),
                      disabled: true, // This is just info, not clickable
                  },
                  {
                      type: 'divider',
                  },
                  {
                      key: 'changePassword',
                      onClick: () => {
                          window.open(
                              `${process.env.REACT_APP_IDP}profile/updatepassword-lite?redurectUrl=${window.location.href}`,
                              '_self'
                          );
                      },
                      label: (
                          <span style={{ padding: '0px 8px' }}>
                              Change Password
                          </span>
                      ),
                  },
                  {
                      key: 'logout',
                      onClick: onLogOut,
                      label: (
                          <span style={{ padding: '0px 8px' }}>Log Out</span>
                      ),
                  },
              ]
            : [
                  {
                      key: 'changePassword',
                      onClick: () => {
                          window.open(
                              `${process.env.REACT_APP_IDP}profile/updatepassword-lite?redurectUrl=${window.location.href}`,
                              '_self'
                          );
                      },
                      label: (
                          <span style={{ padding: '0px 8px' }}>
                              Change Password
                          </span>
                      ),
                  },
                  {
                      key: 'logout',
                      onClick: onLogOut,
                      label: (
                          <span style={{ padding: '0px 8px' }}>Log Out</span>
                      ),
                  },
              ];

    return (
        <Flex
            justify="space-between"
            align="center"
            gap="large"
            style={{ height: '100%', zIndex: 1 }}
        >
            <NavCommunity />

            {breakpoint === 'desktop' && (
                <b
                    style={{
                        color: '#5a7890',
                        fontSize: 18,
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        minWidth: 300,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        maxWidth: 400,
                        flex: '0 1 400px',
                    }}
                >
                    <Link
                        to={'https://www.associatedasset.com/'}
                        style={{
                            marginLeft: 10,
                            fontWeight: 700,
                            display: 'flex',
                            fontSize: '14px',
                        }}
                    >
                        Return to associatedasset.com
                    </Link>
                </b>
            )}
            <Col>
            {breakpoint === 'desktop' && (
                    <Tag title={profile?.email} className="user-tag">
                        <b>Welcome</b>, {profile?.given_name}{' '}
                        {profile?.lastName}
                    </Tag>
                )}
            </Col>

            <Col>
                <Dropdown
                    trigger={['click']}
                    placement="bottomLeft"
                    arrow={{ pointAtCenter: true }}
                    menu={{ items: menuItems }}
                >
                    <UserOutlined
                        style={{
                            fontSize: '20px',
                            background: 'rgba(242, 246, 249, 1)',
                            padding: 10,
                            borderRadius: '50%',
                        }}
                    />
                </Dropdown>
            </Col>
        </Flex>
    );
});

export default NavBar;
